import { inputs } from '@ecosystem/newron-design-system';
import { ListItem } from '@ecosystem/newron-design-system/build/exports/inputs';

const { ListBox } = inputs;

export const WithListBox = ({
  listOption,
  selectedOption,
  setSelectedOption,
  onChange,
  width = 300,
  isOpen,
  setIsOpen,
  combobox = false,
}) => {
  return (
    <ListBox
      list={listOption}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      combobox={combobox}
      width={width}
      onChange={(item) => {
        if (!item) {
          item = selectedOption as ListItem;
        }
        setSelectedOption({
          ...item,
          isDisabled: item.isDisabled ?? false, // Default to false if undefined
        });
        setIsOpen(false);
        onChange(item);
      }}
      value={selectedOption || { label: 'Not Available', value: 'Not Available' }}
      data-retail-insights="listbox"
    ></ListBox>
  );
};
